export default __webpack_public_path__ + "../staticImages/sprite-facebook-2x.png";